import React, { useState } from 'react';
import PageContainer from 'components/PageContainer/PageContainer';
import Formulario from '../../components/public/Formulario/Formulario';
import { IEmail, IFormDatosContactoExt, IFormSocio, IFormato, IFormulario } from 'utils/models/interfaces';
import { datosFormDatosPersonales, tooltips, datosFormContactoExt } from 'utils/formData';
import { useError } from 'services/ErrorContext';
import { solicitudFormularios } from 'services/servicioPost';
import { alturaContainer, anchoMaxForms } from 'utils/constants';
import { Diversity1Outlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

const HaceteSocio = () => {
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario = usuarioJSON && JSON.parse(usuarioJSON);

  const [mensajeExito, setMensajeExito] = useState('');
  const { error, clearError, loading, setError, setLoading } = useError();

  const datosNombreApellido = datosFormDatosPersonales.filter(
    dato => dato.name === 'nombre' || dato.name === 'apellido'
  );

  const datosFormContactoLogueado: IFormato<IFormDatosContactoExt>[] = [
    {
      name: 'Telefono',
      label: 'Teléfono',
      inputType: 'tel',
      halfWidth: 'left',
      pattern: tooltips.telefono.pattern,
      tooltip: tooltips.telefono.tooltip,
      adornment: 'tel',
      defaultValue: usuario?.Telefono,
      subtituloSeccion: 'Completá tu información para que nos podamos poner en contacto contigo',
    },
    {
      name: 'Email',
      label: 'Email',
      required: false,
      inputType: 'email',
      adornment: 'email',
      pattern: tooltips.email.pattern,
      tooltip: tooltips.email.tooltip,
      halfWidth: 'right',
      defaultValue: usuario?.Email,
    },
  ];

  const datosFormSocio: IFormato<IFormSocio>[] = usuario
    ? [...datosFormContactoLogueado]
    : [...datosNombreApellido, ...datosFormContactoExt];

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();

    const nombre = data.nombre || usuario?.Nombre;
    const apellido = data.apellido || usuario?.Apellido;
    const email = data.Email || usuario?.Emai;
    const telefono = data.Telefono || usuario?.Telefono;

    const request: IEmail = {
      Subject: 'Teatro Bosch Web - Nueva solicitud de socio',
      Body: `
      Nombre: ${nombre} <br>
      Apellido: ${apellido}<br>
      Email: ${email ? email : 'No ingresado'} <br>
      Teléfono: ${telefono}<br>
      `,
      Title: `Solicitud de socio`,
    };

    try {
      if (!nombre || !apellido || !telefono) {
        setError('Error en alguno de los datos');
        throw new Error('Error en alguno de los datos');
      }
      await solicitudFormularios('socio', request, setError, setLoading);
      setMensajeExito(`¡Gracias tu solicitud de socio! Nos pondremos en contacto contigo.`);
    } catch (err) {
    }
  }

  const handleVolver = () => {
    setMensajeExito('');
  };

  return (
    <PageContainer marginBottom={true}>
      <Box minHeight={alturaContainer} maxWidth={anchoMaxForms}>
        {!mensajeExito && (
          <Typography variant="h6" fontWeight={600} textAlign="left" lineHeight={1.2} maxWidth="600px">
            ¡Comunicate con nosotros para hacerte socio y acceder a diferentes beneficios y descuentos!
          </Typography>
        )}
        <Formulario
          campos={datosFormSocio}
          onSubmit={handleSubmit}
          onVolver={handleVolver}
          mensajeExito={mensajeExito}
          mensajeError={error}
          loading={loading}
          iconoBoton={Diversity1Outlined}
          textoBoton="Quiero ser socio"
        />
      </Box>
    </PageContainer>
  );
};

export default HaceteSocio;
